var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10.6667C16.7364 10.6667 17.3333 11.2636 17.3333 12V16C17.3333 16.7364 16.7364 17.3333 16 17.3333C15.2636 17.3333 14.6667 16.7364 14.6667 16V12C14.6667 11.2636 15.2636 10.6667 16 10.6667Z",
    fill: "#6F757C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24ZM16 26.6667C21.891 26.6667 26.6667 21.891 26.6667 16C26.6667 10.109 21.891 5.33333 16 5.33333C10.109 5.33333 5.33333 10.109 5.33333 16C5.33333 21.891 10.109 26.6667 16 26.6667Z",
    fill: "#6F757C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0572 25.0572C30.0593 20.055 30.0593 11.945 25.0572 6.94281L26.9428 5.05719C32.9864 11.1007 32.9864 20.8993 26.9428 26.9428L25.0572 25.0572ZM6.94281 6.94281C1.94066 11.945 1.94066 20.055 6.94281 25.0572L5.05719 26.9428C-0.986358 20.8993 -0.986358 11.1007 5.05719 5.05719L6.94281 6.94281Z",
    fill: "#6F757C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 20C17.3333 20.7364 16.7364 21.3333 16 21.3333C15.2636 21.3333 14.6667 20.7364 14.6667 20C14.6667 19.2636 15.2636 18.6667 16 18.6667C16.7364 18.6667 17.3333 19.2636 17.3333 20Z",
    fill: "#6F757C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaims);
export default __webpack_public_path__ + "static/media/claims.6f3307bb7adf19f27c2f3017d7d6ed57.svg";
export { ForwardRef as ReactComponent };